import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { Repeat04Icon } from 'src/editor/shared/icons/repeat-04-icon'
import {
  ButtonSizeEnum,
  GhostIconButton,
} from 'src/editor/shared/ui-lib/buttons'
import { HoverType } from '../../../../../../../../common/types/styleTypes'
import HoverColorStyle from '../../styles/HoverColorStyle'
import HoverTransformStyle from '../../styles/HoverTransformStyle'

interface HoverButtonSettingProps {
  textColor?: string
  backgroundColor?: string
  subTextColor?: string
  hover?: HoverType
  defaultHover?: HoverType
  mobileDefaultHover?: HoverType
  mobileHover?: HoverType
  update: (hover: HoverType) => void
  mobileUpdate: (hover: HoverType) => void
}

function HoverButtonSetting({
  hover,
  defaultHover,
  mobileDefaultHover,
  mobileHover,
  update,
  mobileUpdate,
  textColor,
  backgroundColor,
  subTextColor,
}: HoverButtonSettingProps) {
  const onResetStyles = () => {
    if (defaultHover) {
      update(defaultHover)
      mobileUpdate(mobileDefaultHover || defaultHover)
    }
  }
  return (
    <>
      <GroupTitle
        afterChildren={
          defaultHover && (
            <GhostIconButton
              size={ButtonSizeEnum.Small}
              onClick={onResetStyles}
              icon={<Repeat04Icon />}
            />
          )
        }
      >
        entity_settings.button.hover_effect.group_title
      </GroupTitle>
      <HoverColorStyle
        update={update}
        mobileUpdate={mobileUpdate}
        hover={hover}
        mobileHover={mobileHover}
        backgroundColor={backgroundColor}
        textColor={textColor}
        subTextColor={subTextColor}
      />
      <HoverTransformStyle
        update={update}
        mobileUpdate={mobileUpdate}
        transformHover={hover}
        mobileTransformHover={mobileHover}
      />
    </>
  )
}

export default HoverButtonSetting
